import { render, staticRenderFns } from "./ssr-blocked.vue?vue&type=template&id=44918847&scoped=true"
import script from "./ssr-blocked.vue?vue&type=script&lang=js"
export * from "./ssr-blocked.vue?vue&type=script&lang=js"
import style0 from "./ssr-blocked.vue?vue&type=style&index=0&id=44918847&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44918847",
  null
  
)

export default component.exports